import * as Sentry from "@sentry/react";
import { AuthenticatedUserContext } from "@ngt/opms"
import { useContext, useEffect } from "react"

const useSentryUser = () => {
    const {data: authenticatedUser} = useContext(AuthenticatedUserContext);

    useEffect(() => {
        if(!authenticatedUser) {
            Sentry.setUser(null);
            return;
        }
        
        Sentry.setUser({
            id: authenticatedUser.userName,
            username: authenticatedUser.userName,
            fullName: authenticatedUser.displayName
        })

        return () => {
            Sentry.setUser(null);
        }
    }, [authenticatedUser])
}

export default useSentryUser;